//
//
//
//
//

export default {
  name: 'FlexBox',
  props: {
    gutter: {
      type: [Number, String],
      default: '8'
    },
    direction: {
      type: String
    },
    warp: {
      type: String
    },
    align: {
      type: String
    },
    justify: {
      type: String
    }

  },
  data () {
    return {
      num: parseFloat(this.gutter)
    }
  },

  computed: {
    unit () {
      if (typeof this.gutter === 'number') {
        return 'px'
      } else {
        let arr = this.gutter.split(this.num)
        if (arr.length > 1) {
          return arr[1]
        } else {
          return 'px'
        }
      }
    },
    style () {
      return {
        flexDirection: this.direction,
        flexWrap: this.wrap,
        justifyContent: this.justify,
        alignItems: this.align,
        marginLeft: `${-this.num / 2}${this.unit}`,
        marginRight: `${-this.num / 2}${this.unit}`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/flexbox/FlexBox.vue